
export class KeyValue<keyType,valueType> {
  public key: keyType;
  public value: valueType;
  constructor(k: keyType, v: valueType) {
    this.key = k;
    this.value = v;
  }
}

export class Dictionary<keyType, valueType> {
  private keyValues: KeyValue<keyType, valueType>[];

  constructor() {
    this.keyValues = [];
  }

  public has(key: keyType): boolean {
    let res = this.keyValues.some(x => x.key == key);
    return res;
  }

  public keyValue(key: keyType): valueType {
    let res = this.keyValues.find(x => x.key == key);
    return (res ? res.value : null);
  }

  public add(key: keyType, value: valueType): valueType {
    if (!this.has(key)) {
      this.keyValues.push(new KeyValue<keyType, valueType>(key, value));
    }
    this.keyValues.filter(x => x.key == key)[0].value = value;
    return value;
  }

  public remove(key: keyType): void {
    this.keyValues = this.keyValues.filter(x => x.key != key);
  }

  public get all(): KeyValue<keyType, valueType>[] {
    return this.keyValues;
  }

  public get allKeys(): keyType[] {
    return this.keyValues.map(x => x.key);
  }

  public get count(): number {
    return this.keyValues.length;
  }

  public clear(): void {
    this.keyValues = [];
  }
}


export class HashSet<T> {
  private keys: T[];

  constructor() {
    this.keys = [];
  }

  public has(key: T): boolean {
    let res = this.keys.some(x => x == key);
    return res;
  }

  public contains(key: T): boolean {
    return this.has(key);
  }

  public add(key: T): void {
    if (!this.has(key)) {
      this.keys.push(key);
    }
  }

  public remove(key:T): void {
    this.keys = this.keys.filter(x => x != key);
  }

  public get all(): T[] {
    return this.keys;
  }

  public get count(): number {
    return this.keys.length;
  }

  public clear(): void {
    this.keys = [];
  }
} 


export class AppConfig {
  title: string;
}

export class Facet {
  text: string;
  id: number;
  renderMode: number;
  isAnd: boolean;
  visible: boolean;
  displayOrder: number;
}

export class FacetValue {
  text: string;
  id: number;
  count: number;
  facetId: number;
}

export class FacetSearchCriteria extends HashSet<number>  {
  //private facetCriteria[]: string;
  private facet: Facet;
  public get facetId(): number {
    return this.facet.id;
  }
  public get isAnd(): boolean {
    return this.facet.isAnd;
  }

  constructor(facet: Facet) {
    super();
    this.facet = facet;
  }
  
  public toQueryString(): string {
    let allItems = this.all;
    let facetValueIds: string[] = new Array();
    for (let i in allItems) {
      //console.log("item=" + allItems[i]);
      facetValueIds.push(allItems[i].toString());
    }
    let result = facetValueIds.join();
    //console.log("FacetSearchCriteria.toString() = " + result);
    return result;
  }
 
  public toString(): string {
    let allItems = this.all;
    let facetValueIds: string[] = new Array();
    for (let i in allItems) {
      //console.log("item=" + allItems[i]);
      facetValueIds.push(allItems[i].toString());
    }
    let result = facetValueIds.join();
    //console.log("FacetSearchCriteria.toString() = " + result);
    return result;
  }
}


export class SearchCriteria extends Dictionary<number, FacetSearchCriteria> {// <facet, 
  public text: string;
  //private facetSearchCriteria: FacetSearchCriteria[];

  constructor() {
    super();
    this.text = "";
  }
  
  public setCriteria(f: FacetSearchCriteria) {
    this.add(f.facetId, f);
  }

  public toFacetQueryString() {
    let allFacets = this.all;
    let facetQueries: string[] = new Array();
    for (let i in allFacets) {
      let facetCriteriaString = allFacets[i].value.toQueryString();
      if (facetCriteriaString.length > 0) {
        facetQueries.push(facetCriteriaString);
      }
    }
    // this is the "and" of all the groups of facet value IDs.
    return facetQueries.join(";");
  }

 
  public static fromString(s: string): SearchCriteria {
    var result = new SearchCriteria();
    var s1 = JSON.parse(s);
    for (let i in s1.keyValues) {
      let facetId: number = s1.keyValues[i].key;
      let facet: Facet = s1.keyValues[i].value.facet;
      let facetSearchCriterion = new FacetSearchCriteria(facet);
      let selectedFacetValues: number[] = s1.keyValues[i].value.keys;
      for (let k in selectedFacetValues) {
        facetSearchCriterion.add(selectedFacetValues[k]);
      }
      result.add(facetId, facetSearchCriterion);
    }
    result.text = s1.text;
    return result;
  }

  public toString(): string {
    return JSON.stringify(this);
  }

}


export class Preset {
  public id: number;
  public presetName: string;
  public presetValue: string;
  public displayOrder: number;
}


export class SearchResult {
  public id: number;
  public title: string;
  public html: string;
}

export class FacetRenderMode {
  public id: number;
  public renderMode: string;
}

export class BuildInfo {
  public BuildTime: string;
  public ChangeSet: string;
  public BuildNumber: string;
  public BuildAgent: string;
  public Builder: string;
  public BuildJob: string;
  public BuildOutputUrl: string;
  public ChangeSetUrl: string;
  public BuildUrl: string;
}

export class AppBuildInfo {
  appBuildInfo: { "changeSet": string; "buildNumber": string; "buildJob": string; "buildAgent": string; "buildTime": string; };
  public apiBuildInfo: BuildInfo;
  public webBuildInfo: any;
}




// WEBPACK FOOTER //
// ./src/app/fsapplication/webapi/faceted-search-app.model.ts